import billingInputTypes from './billing-input-types';

export const getValueByInputType = (type, value) => {
  if (!value) return '';

  switch (type) {
    case billingInputTypes.select:
    case billingInputTypes.boardSelect:
      return value.value;
    default:
      return value;
  }
};
